import React, { FunctionComponent } from 'react';
import { Presentation } from './presentation';
import { useIsMobile } from '../../../hooks/useIsMobile';
import type { Props } from './types';

export const Component: FunctionComponent<Props> = ({ events, noimage }) => {
  const isMobile = useIsMobile();

  return (
    <Presentation events={events} isMobile={isMobile} noimage={noimage} />
  );
};
